import { render, staticRenderFns } from "./MonitorPanel.vue?vue&type=template&id=51578ad6"
import script from "./MonitorPanel.vue?vue&type=script&lang=js"
export * from "./MonitorPanel.vue?vue&type=script&lang=js"
import style0 from "./MonitorPanel.vue?vue&type=style&index=0&id=51578ad6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports